import React from 'react';
import PropTypes from 'prop-types';
import FingerprintBannerPageSection from '../../design-system/FingerprintBannerPageSection';
import { HeadingArticle } from '../../design-system/Headings';

export default function WelcomeBannerSection({ profileFullName, salutation }) {
  return (
    <FingerprintBannerPageSection borderB>
      <HeadingArticle el="h1" my0>
        <>
          {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
          {salutation}{' '}
          <span className="ss_d--inline-block">{profileFullName}</span>
        </>
      </HeadingArticle>
    </FingerprintBannerPageSection>
  );
}

WelcomeBannerSection.propTypes = {
  profileFullName: PropTypes.string.isRequired,
  salutation: PropTypes.string.isRequired,
};
